// @flow

import { combineEpics, ActionsObservable } from 'redux-observable';
import { switchMap, map, filter, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { GET_CONTENT, GET_CONTENT_DONE } from '../actions';
import type { ContentActions } from '../types';

export const getContentEpic = (action$: ActionsObservable<ContentActions>, state$: any) =>
  action$.pipe(
    filter((action) => action.type === GET_CONTENT),
    switchMap((request) => {
      const contentObj = state$.value.content.contents.find((item) => item.key === request.payload);

      if (contentObj && contentObj.content !== '') {
        return of({
          type: GET_CONTENT_DONE,
          payload: { key: request.payload, content: contentObj.content },
        });
      }

      if (contentObj && contentObj.url !== '') {
        return ajax({
          url: contentObj.url.replace('{lang}', state$.value.i18n.language),
          responseType: 'text',
        }).pipe(
          map((response) => {
            return {
              type: GET_CONTENT_DONE,
              payload: { key: request.payload, content: response.response },
            };
          }),
          catchError(() =>
            of({
              type: GET_CONTENT_DONE,
              payload: { key: request.payload, content: '' },
            })
          )
        );
      }

      return of({
        type: GET_CONTENT_DONE,
        payload: { key: request.payload, content: '' },
      });
    })
  );

export const contentEpics = combineEpics(getContentEpic);
